import React from 'react';
import { Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { MenuItem as MenuItemType } from '../../../types/Menu';
import { Product } from '../../../types/Product';
import { MenuItemProduct } from './MenuItemProduct';
import { useProducts } from '../../../context/ProductContext';

interface MenuItemProps {
  item: MenuItemType;
  index: number;
}

export const MenuItem: React.FC<MenuItemProps> = ({ item, index }) => {
  const { products } = useProducts();

  if (!products || !Array.isArray(products)) {
    return null;
  }

  const itemProducts = item.products
    .map(id => products.find(p => p.id === id))
    .filter((p): p is Product => p !== undefined);

  if (itemProducts.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.1 }}
      className="mb-4 p-4 bg-orange-50 rounded-lg hover:shadow-md transition-shadow"
    >
      <div className="flex justify-between items-center mb-2">
        <h4 className="font-medium flex items-center gap-2">
          <Clock className="text-orange-500" size={16} />
          {item.name}
        </h4>
        <span className="text-green-600 font-semibold">
          {item.totalPrice.toFixed(2)}€
        </span>
      </div>

      <div className="grid grid-cols-1 gap-2">
        {itemProducts.map((product) => (
          <MenuItemProduct key={product.id} product={product} />
        ))}
      </div>
    </motion.div>
  );
};